import { Image } from 'lucide-react';
import { useEditorStore } from '../../../store/editorStore';
import { resolveMediaUrl } from '../../../lib/mediaUrl';

export default function ImageLayerRenderer({ layer }) {
  const data = layer.data;
  const toggleMediaLibrary = useEditorStore((s) => s.toggleMediaLibrary);

  if (!data.src) {
    return (
      <div
        className="w-full h-full flex flex-col items-center justify-center gap-2
                   bg-gray-800/60 border-2 border-dashed border-gray-600 rounded cursor-pointer
                   hover:border-indigo-500 transition-colors"
        onClick={(e) => { e.stopPropagation(); toggleMediaLibrary(); }}
      >
        <Image size={24} className="text-gray-500" />
        <span className="text-xs text-gray-500">Click to choose image</span>
      </div>
    );
  }

  const focal = data.focalPoint;
  const pos = focal ? `${focal.x * 100}% ${focal.y * 100}%` : 'center';

  return (
    <img
      src={resolveMediaUrl(data.src)}
      alt={data.alt || ''}
      style={{
        width: '100%',
        height: '100%',
        objectFit: data.objectFit || 'cover',
        objectPosition: pos,
        display: 'block',
        pointerEvents: 'none',
      }}
      draggable={false}
    />
  );
}
